<template>
  <div
    @click="name ? $emit('selected-click') : null"
    class="inline-flex items-center w-full justify-between text-slate-800 dark:text-slate-50 px-2 py-1"
    style="min-height: 30px;"
  >
    <div class="inline-flex items-center cursor-pointer">
      <Ligne :name="ligne" :size="'medium'" />
      <div class="mx-4">
        <h2 v-if="name" class="text-m">{{ name.trunc(22) }}</h2>
        <h1 v-else class="text-lg">{{ station.trunc(22) }}</h1>
        <div
          class="text-sm text-left text-gray-700 dark:text-white"
          v-if="direction"
        >
          {{ direction.trunc(15) }}
        </div>
      </div>
    </div>
    <div class="mx-2" v-if="next">
      <h1 class="text-lg">{{ next }}</h1>
    </div>
    <div
      v-if="station && !direction"
      class="mr-2 text-xl text-gray-600 dark:text-white"
    >
      <svg
        height="15px"
        width="15px"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        data-name="Layer 1"
        viewBox="0 0 100 100"
        x="0px"
        y="0px"
      >
        <path
          d="M36.66,12.71a5,5,0,0,0-7.07,7.07L59.8,50,29.59,80.22a5,5,0,1,0,7.07,7.07L70.41,53.54a5,5,0,0,0,0-7.07Z"
        ></path>
      </svg>
    </div>
  </div>
</template>

<script>
import Ligne from "@/components/Ligne";

String.prototype.trunc = function(n) {
  return this.substr(0, n - 1) + (this.length > n ? ".." : "");
};

export default {
  name: "LigneStation",
  components: {
    Ligne
  },
  props: {
    ligne: String,
    station: String,
    name: String,
    direction: String,
    next: String
  }
};
</script>
